import { GameObject } from "../../../api/src/game-base/gameObjects/GameObject";
import { BaseRouteService } from "./BaseRouteService";

export class InventoryService extends BaseRouteService {
    public async listItems(): Promise <GameObject[]> {
        return this.getJsonApi<GameObject[]>("inventory/inventory");
    }
}
